import React, { Fragment } from 'react'
import { object, array } from 'prop-types'
import { parkingIconsForMap } from '../../../utils/ParkingIcons'

const Sign = ({ sign }) => (
  <div className="same-support-signs">
    <div className="sign-icon">
      <img
        src={parkingIconsForMap(sign)}
        alt={sign.properties.sign_description}
      />
    </div>
    <div className="sign-information">
      <p>{sign.properties.sign_description}</p>
      <p>
        <strong>{sign.properties.distance_from_intersection} Ft</strong> from{' '}
        <strong>{sign.properties.from_street}</strong>
      </p>
      <p>
        On the <strong>{sign.properties.sos_new[1]}</strong> of{' '}
        <strong>{sign.properties.on_street}</strong>
      </p>
      {sign.properties.arrow_points && (
        <p>
          Arrow points to the <strong>{sign.properties.arrow_points}</strong>
        </p>
      )}
    </div>
  </div>
)

const SamePointSigns = ({ signs, message }) => {
  return (
    <Fragment>
      <h3 className="same-support-message">{message}</h3>
      <hr />
      {signs.map(sign => (
        <Sign sign={sign} key={sign.properties.id} />
      ))}
    </Fragment>
  )
}

SamePointSigns.propTypes = {
  signs: array.isRequired,
}

Sign.propTypes = {
  sign: object.isRequired,
}

export default SamePointSigns



// WEBPACK FOOTER //
// ./src/components/Map/Markers/SamePointSigns.jsx